/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropheroupload2Inputs */

const en_dropheroupload2 = /** @type {(inputs: Dropheroupload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload hero image`)
};

const de_dropheroupload2 = /** @type {(inputs: Dropheroupload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild hochladen`)
};

/**
* | output |
* | --- |
* | "Upload hero image" |
*
* @param {Dropheroupload2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropheroupload2 = /** @type {((inputs?: Dropheroupload2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropheroupload2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropheroupload2(inputs)
	return de_dropheroupload2(inputs)
});
export { dropheroupload2 as "dropHeroUpload" }